import { render, staticRenderFns } from "./AcademicFormation.vue?vue&type=template&id=19cede9e&scoped=true&"
import script from "./AcademicFormation.vue?vue&type=script&lang=ts&"
export * from "./AcademicFormation.vue?vue&type=script&lang=ts&"
import style0 from "./AcademicFormation.vue?vue&type=style&index=0&id=19cede9e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cede9e",
  null
  
)

export default component.exports